import React from "react";
import { observer } from "mobx-react";
import { CountryUpdateStore } from "../../store";
import { CountryUpdateForm } from "./CountryUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type CountryUpdateProps = {
  countryUpdateStore: CountryUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CountryUpdate: React.FC<CountryUpdateProps> = observer(
  ({ countryUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={countryUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={countryUpdateStore.savedButOutdated}
          onReload={() => countryUpdateStore.reloadCountry()}
          reloadDisabled={countryUpdateStore.isProcessing}
        />
        <CountryUpdateForm
          countryUpdateStore={countryUpdateStore}
          name_esError={countryUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            countryUpdateStore.setName_esValue(value);
          }}
          name_es={countryUpdateStore.entityValues.name_es}
          name_enError={countryUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            countryUpdateStore.setName_enValue(value);
          }}
          name_en={countryUpdateStore.entityValues.name_en}
          name_ptError={countryUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            countryUpdateStore.setName_ptValue(value);
          }}
          name_pt={countryUpdateStore.entityValues.name_pt}
          codeError={countryUpdateStore.errors.code?.message}
          onCodeChange={(value: string) => {
            countryUpdateStore.setCodeValue(value);
          }}
          code={countryUpdateStore.entityValues.code}
          currencyError={countryUpdateStore.errors.currency?.message}
          onCurrencyChange={(value: string) => {
            countryUpdateStore.setCurrencyValue(value);
          }}
          currency={countryUpdateStore.entityValues.currency}
          demonym_esError={countryUpdateStore.errors.demonym_es?.message}
          onDemonym_esChange={(value: string) => {
            countryUpdateStore.setDemonym_esValue(value);
          }}
          demonym_es={countryUpdateStore.entityValues.demonym_es}
          demonym_enError={countryUpdateStore.errors.demonym_en?.message}
          onDemonym_enChange={(value: string) => {
            countryUpdateStore.setDemonym_enValue(value);
          }}
          demonym_en={countryUpdateStore.entityValues.demonym_en}
          demonym_ptError={countryUpdateStore.errors.demonym_pt?.message}
          onDemonym_ptChange={(value: string) => {
            countryUpdateStore.setDemonym_ptValue(value);
          }}
          demonym_pt={countryUpdateStore.entityValues.demonym_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={countryUpdateStore.saveDisabled}
          onSave={() => countryUpdateStore.saveCountry()}
          onCancel={() => countryUpdateStore.cancelCountry()}
        />
        <ErrorDialog
          open={countryUpdateStore.errorDialogOpened}
          title={countryUpdateStore.errorTitle}
          description={countryUpdateStore.errorDescription}
          onClose={() => countryUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={countryUpdateStore.confirmDialogOpened}
          title={countryUpdateStore.confirmDialogTitle}
          description={countryUpdateStore.confirmDialogDescription}
          onConfirm={() => countryUpdateStore.executeConfirmedAction()}
          onCancel={() => countryUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
